import React from 'react'

import s from './ui.style.css'
import useTranlation from '../../translation/hook'

import UICardType from './cardType.ui.component'
import UICardMaterial from './cardMaterial.ui.component'
import UICardColor from './cardColor.ui.component'
import UICardPattern from './cardPattern.ui.component'
import UICardText from './cardText.ui.component'
import UICardLogo from './cardLogo.ui.component'


import { useAppState } from '../../state/app.state'


export default function UIContainer(){
    const appState = useAppState()
    const t = useTranlation()
    const {cardType, hideUi} = appState.state
    return (
        <div className="uiContainer">
            <UICardType {...appState}/>
            {!hideUi && (
                <div className="cardUiPanel">
                    <div className="panelRow">
                        <UICardMaterial {...appState} />
                        { cardType.colorSelection && <UICardColor {...appState} />}
                    </div>
                    { !hideUi && cardType.patternSelection && <UICardPattern {...appState} />}
                    { !hideUi && cardType.customText && <UICardText {...appState }/> }
                    { !hideUi && cardType.customLogo && <UICardLogo {...appState} /> }
                    { !hideUi && cardType.name === "one edition" ? (
                        <p style={{width: 350}}>{t("site_pages_shop_app_one_edition_info")}</p>
                    ) : null}

                </div>
            )}
        </div>
    )
}




